import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'temperature'
})
export class TemperaturePipe implements PipeTransform {

  transform(
    value: number | undefined,
    unitStyle: 'symbol' | 'unicode' = 'symbol',
    round: boolean = true
  ): string {
    if (value === undefined || value === null || isNaN(value)) {
      return '';
    }

    const displayValue = round ? Math.round(value) : value;
    const unit = unitStyle === 'unicode' ? '℃' : '°';
    return `${displayValue}${unit}`;
  }
}
